<div usbLoadingSplash [appLoading]="appLoading" [fullscreen]="true" [component]="'yourtrip'">
  <div>
    <div class="d-flex flex-column">
      <div class="data-name-itinerary font-poppins mb-2">
        <h4 class="w-100" style="color: #000000; font-size: 35.73px;">{{ nameItinerary }}</h4>
      </div>

      <!-- Location - Datetime - Passengers -->
      <div
        class="row w-100 m-0"
        style="border: 1px solid #dfdfdf; border-radius: 6px; background-color: #FFFFFF; min-height: 65px;"
      >
        <!-- Location -->
        <div class="col-4 p-0">
          <div style="border-right: 1px solid #dfdfdf">
            <div class="px-2 py-1 d-flex align-items-center">
              <img width="50px" height="50px" src="../../../../assets/icons/itinerary/ubicacion.svg" alt="" />

              <p class="mb-0" style="font-family: &quot;Rubik&quot;, serif; font-size: 15px">
                {{ destinySecuency }}
              </p>
            </div>
          </div>
        </div>

        <!-- Datetime -->
        <div class="col-5 p-0">
          <div class="h-100" style="border-right: 1px solid #dfdfdf;">
            <div class="h-100 d-flex align-items-center pl-4">
              <img class="mr-2" width="35px" src="../../../../assets/icons/itinerary/calendar_13937514.svg" alt="" />

              <p class="mb-0 ml-1" style="font-family: &quot;Rubik&quot;, serif; font-size: 15px">
                Start: {{ userService.itineraryArrivalDateFull | date: "dd MMM yy" }} - End:
                {{ userService.itineraryDepartureDateFull | date: "dd MMM yy" }}
                &nbsp;
                <span *ngIf="existHotel()" style="font-weight: 700; border-left: 1px solid #000000; padding-left: 0.8em">
                  {{ qtyDays }} Días {{ qtyNights }} {{ qtyNights > 1 ? "Noches" : "Noche" }}</span
                >
              </p>
            </div>
          </div>
        </div>


        <!-- Passengers -->
        <div class="col-3 p-0">
          <div class="h-100 d-flex align-items-center pl-5">
            <img class="mr-2" width="25px" src="../../../../assets/icons/itinerary/persona.svg" alt="" />
            <p class="mb-0 ml-1" style="font-family: &quot;Rubik&quot;, serif; font-size: 15px">
              {{ adults }} {{ adults > 1 ? "adultos" : "adulto" }} - {{ children }} {{ children === 1 ? "niño" : "niños" }}
            </p>
          </div>
        </div>
      </div>

      <!-- Flight Modal Component -->
      <usb-flight-modal
        class="align-items-center d-flex flex-row w-100"
        *ngIf="actualItinerary"
        style="border: 1px solid #dfdfdf; border-radius: 6px; margin-top: 10px"
        [invoke]="1"
        [_actualItinerary]="actualItinerary"
        [getClientsSettingAppBooking]="getClientsSettingAppBooking"
        (updateFly)="onUpdateFly($event)"
      >
      </usb-flight-modal>
    </div>
  </div>
</div>
